export const BxSubscript = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.17707 6.22064H5.34855L7.64119 9.73416L9.96178 6.22064L12.0028 6.26724L8.63839 11.0855L12.1519 16.202H10.0084L7.52935 12.4555L5.12488 16.202H3L6.51351 11.0855L3.17707 6.22064Z"
        fill="#666C7A"
      />
      <path
        d="M15.2089 13.7031C15.0901 13.561 14.92 13.4899 14.6987 13.4899C14.3958 13.4899 14.1896 13.6029 14.0801 13.8289C14.0172 13.9594 13.9799 14.1668 13.9683 14.451H13.0002C13.0165 14.02 13.0946 13.6717 13.2343 13.4061C13.5 12.9005 13.9718 12.6477 14.6498 12.6477C15.1857 12.6477 15.612 12.7968 15.9289 13.095C16.2458 13.3909 16.4042 13.7835 16.4042 14.2728C16.4042 14.6479 16.2924 14.9811 16.0687 15.2723C15.9219 15.4657 15.6808 15.6812 15.3452 15.9189L14.9468 16.202C14.6975 16.379 14.5263 16.5072 14.4331 16.5864C14.3422 16.6656 14.2653 16.7576 14.2024 16.8625H16.4147V17.7397H12.9443C12.9536 17.3762 13.0316 17.0442 13.1784 16.7437C13.3206 16.4058 13.6561 16.0482 14.185 15.6707C14.6439 15.3422 14.941 15.1069 15.0761 14.9648C15.2835 14.7434 15.3872 14.5011 15.3872 14.2378C15.3872 14.0235 15.3278 13.8452 15.2089 13.7031Z"
        fill="#666C7A"
      />
    </svg>
  )
}
